import { Component } from '@angular/core';

@Component({
  selector: 'app-gratuidade-de-publicacao',
  standalone: true,
  imports: [],
  template: `
    <div>
      <p>Publicar no Diário Oficial é uma obrigação legal para que diversos atos oficiais sejam considerados válidos. Mas você sabia que entidades filantrópicas e associações comunitárias podem solicitar a publicação gratuita dessas matérias?</p>
      <p>Nesta página, você encontra o passo a passo de como apresentar o pedido de gratuidade de publicação para a entidade que representa.  Veja quem pode solicitar, quais são os documentos necessários e como realizar o procedimento utilizando o Sistema Eletrônico de Informações (SEI!MG) do Governo de Minas Gerais.</p>      
    </div>
  `
})
export class GratuidadeDePublicacaoComponent {

}
